module.exports = __webpack_public_path__ + "img/jianjie11@2x.d759e95e.png";